export default __webpack_public_path__ + "static/media/thcreators2030logo11.c8a68653.png";